import { useQuery } from 'react-query';
import { AxiosError } from 'axios';
import api from 'services';
import { ApiError } from 'services/api.errors';
import { ProfileListResponse } from 'services/requests';
import { QueryKeys } from 'constants/queryKeys';

export const useGetProfileList = (email?: string) => {
  const queryFn = async () => {
    const { data } = await api.getProfileList(email);
    return data;
  };

  const queryKey = [QueryKeys.profileList, email];

  return useQuery<ProfileListResponse, AxiosError<ApiError>>(queryKey, queryFn, {
    enabled: !!email,
  });
};
